<app-breadcrumbs title="Item" [breadcrumbItems]="breadCrumbItems"></app-breadcrumbs>

<div class="row">
  <div class="col-lg-12">
    <div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <h5>Items</h5>
    <button class="btn btn-success" (click)="toggleForm()">
      <i [class]="showForm ? 'ri-close-line' : 'ri-add-line'"></i>
      {{ showForm ? 'Cancel' : 'Add Item' }}
    </button>
  </div>

  <div *ngIf="showForm" class="card-body border-bottom">
    <form [formGroup]="itemForm" (ngSubmit)="saveItem()">
      <div class="row g-3">
        <div class="col-md-3">
          <label>Name</label>
          <input formControlName="name" class="form-control" />
        </div>
        <div class="col-md-3">
          <label>Code 
            <i class="ri-information-line text-primary" 
               ngbTooltip="Format: ITEM001" 
               placement="top"></i>
          </label>
          <input formControlName="code" class="form-control" placeholder="e.g., ITEM001" />
        </div>
        <div class="col-md-3">
          <label>Category</label>
          <select formControlName="category_id" class="form-control">
            <option value="">Select</option>
            <option *ngFor="let c of categories" [value]="c.id">{{ c.name }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label>Unit</label>
          <select formControlName="unit_id" class="form-control">
            <option value="">Select</option>
            <option *ngFor="let u of units" [value]="u.id">{{ u.name }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label>GST Rate (%)</label>
          <input type="number" formControlName="gst_rate" class="form-control" />
        </div>
        <div class="col-md-3">
          <label>HSN Code</label>
          <input formControlName="hsn_code" class="form-control" />
        </div>
        <div class="col-md-3">
          <label>Minimum Stock</label>
          <input type="number" formControlName="minimum_stock" class="form-control" />
        </div>
        <div class="col-md-3" *ngIf="isEditMode">
          <label>Current Stock</label>
          <input type="number" formControlName="current_stock" class="form-control" />
        </div>
        <div class="col-md-3 d-flex align-items-center">
          <input type="checkbox" formControlName="is_active" class="form-check-input me-2" />
          <label>Active</label>
        </div>
      </div>

      <div class="mt-3 text-end">
        <button class="btn btn-light" type="button" (click)="toggleForm()">Cancel</button>
        <button class="btn btn-success" type="submit">{{ isEditMode ? 'Update' : 'Save' }}</button>
      </div>
    </form>
  </div>

  <div class="card-body">
    <div *ngIf="isLoading" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div *ngIf="!isLoading">
      <table class="table">
        <thead class="table-light">
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Category</th>
            <th>GST %</th>
            <th>HSN</th>
            <th>Min Stock</th>
            <th>Current</th>
            <th>Unit</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Items">
            <td>{{ item?.code }}</td>
            <td>{{ item?.name }}</td>
            <td>{{ item?.category?.name }}</td>
            <td>{{ item?.gstRate | number:'1.0-2'  }}</td>
            <td>{{ item?.hsnCode }}</td>
            <td>{{ item?.minimumStock | number:'1.0-2' }}</td>
            <td>{{ item?.currentStock | number:'1.0-2' }}</td>
            <td>{{ item?.unit?.name }}</td>
            <td>
              <span [ngClass]="item.isActive ? 'true' : 'text-danger'">
                {{ item.isActive ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="d-flex gap-2">
              <button class="btn btn-sm btn-success" (click)="editItem(item)"><i class="ri-edit-2-line"></i></button>
              <button class="btn btn-sm btn-danger" (click)="deleteItem(item.id)"><i class="ri-delete-bin-line"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="Items.length > 0" class="mb-2 row">
        <div class="dataTables_info mb-2 col col-sm-6">
            Showing {{ (page - 1) * pageSize + 1 }}
            to {{ getMin(page * pageSize, totalItems) }}
            of {{ totalItems }} entries
        </div>
        <div class="col col-sm-6">
            <div class="text-sm-end float-end listjs-pagination">
                <ngb-pagination
                    [collectionSize]="totalItems"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    (pageChange)="changePage($event)">
                </ngb-pagination>
            </div>
        </div>
    </div>
  </div>

   
  </div>
</div>
